export const IMAGE_PREFIX = process.env.NODE_ENV === 'production' ? '/wp-content/themes/dividualism.k-hirano.com/trial-assets/' : '';
